import i18n from "@/i18n";

export default () => {
  return [
    {
      icon: "highlight",
      link: "/dpa_Select_WebApp_Tips.pdf",
      target: "_blank",
      title: i18n.t("helpMenu.tips")
    },
    {
      icon: "play_circle_outline",
      link: "https://www.youtube.com/watch?v=R5CumJLvR4M",
      target: "_blank",
      title: i18n.t("helpMenu.videoTutorials")
    },
    {
      icon: "mdi-emoticon",
      link:
        "mailto:select-feedback@dpa.com?subject=Feedback%20zur%20dpa-Select-WebApp",
      title: i18n.t("helpMenu.feedback")
    },
    {
      icon: "mail_outline",
      link: "mailto: kundenservice.desk@dpa.com",
      title: i18n.t("helpMenu.support")
    }
  ];
};
